import React, { useState } from "react";

export default function DetailClientModal({ onClose, client }) {
    const [status, setStatus] = useState(client.status_projeto); // Gerenciar status selecionado

    // Função que valida o tipo do arquivo
    function handleFileChange(event) {
        const file = event.target.files[0];
        if (file) {
            if (file.type !== 'application/pdf') {
                document.getElementById('error-message').classList.remove('hidden');
                event.target.value = '';
            } else {
                document.getElementById('error-message').classList.add('hidden');
            }
        }
    }

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50 p-4">
        <div className="glass-panel p-8 w-full max-w-4xl bg-slate-900/90 shadow-2xl border-white/10 relative overflow-y-auto max-h-[90vh]">
            {/* Título */}
            <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-white">{client.nome}</h2>
            </div>

            <hr className="border-t border-white/10 my-6" />

            {/* Dados Pessoais */}
            <h5 className="text-xl font-semibold text-gray-200 mt-6">Dados Pessoais</h5>
            <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                <div>
                    <label className="block text-sm text-gray-500">CPF/CNPJ</label>
                    <p className="text-gray-200">{client.cpf_cnpj}</p>
                </div>
                <div>
                    <label className="block text-sm text-gray-500">Email</label>
                    <p className="text-gray-200">{client.email}</p>
                </div>
                <div>
                    <label className="block text-sm text-gray-500">Telefone</label>
                    <p className="text-gray-200">{client.telefone}</p>
                </div>
            </div>

            <h5 className="text-xl font-semibold text-gray-200 mt-10">Endereço</h5>
            <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                <div>
                    <label className="block text-sm text-gray-500">Cidade</label>
                    <p className="text-gray-200">{client.cidade}</p>
                </div>
                <div>
                    <label className="block text-sm text-gray-500">Bairro</label>
                    <p className="text-gray-200">{client.bairro}</p>
                </div>
                <div>
                    <label className="block text-sm text-gray-500">Estado</label>
                    <p className="text-gray-200">{client.estado}</p>
                </div>
                <div>
                    <label className="block text-sm text-gray-500">Cep</label>
                    <p className="text-gray-200">{client.cep}</p>
                </div>
                <div>
                    <label className="block text-sm text-gray-500">Logradouro</label>
                    <p className="text-gray-200">{client.rua}</p>
                </div>
            </div>

            {/* Status do Projeto */}
            {/*<h5 className="text-xl font-semibold text-gray-200">Projeto</h5>*/}
            {/*<div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">*/}
            {/*    <div>*/}
            {/*        <label className="block text-sm text-gray-500">Status Atual</label>*/}
            {/*        <p className="text-gray-200">{status}</p>*/}
            {/*    </div>*/}

            {/*    <div>*/}
            {/*        <label className="block text-sm text-gray-500">Data de Início</label>*/}
            {/*        /!*<p className="text-gray-200">{client.data_inicio}</p>*!/*/}
            {/*        <p className="text-gray-200">01-01-2025</p>*/}
            {/*    </div>*/}
            {/*    <div>*/}
            {/*        <label className="block text-sm text-gray-500">Data de Término</label>*/}
            {/*        /!*<p className="text-gray-200">{client.data_termino}</p>*!/*/}
            {/*        <p className="text-gray-200">01-02-2025</p>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Arquivos */}
            {/*<h5 className="text-xl font-semibold text-gray-200">Arquivos</h5>*/}
            {/*<div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 mt-2 flex border p-4">*/}
            {/*    <div className="mb-6 flex-1">*/}
            {/*        /!* Seção de arquivos cadastrados *!/*/}
            {/*        {client.arquivos && client.arquivos.length > 0 ? (*/}
            {/*            <ul className="list-disc pl-6">*/}
            {/*                {client.arquivos.map((arquivo, index) => (*/}
            {/*                    <li key={index} className="text-gray-200">*/}
            {/*                        <a*/}
            {/*                            href={arquivo.url}*/}
            {/*                            target="_blank"*/}
            {/*                            rel="noopener noreferrer"*/}
            {/*                            className="text-blue-600 hover:underline"*/}
            {/*                        >*/}
            {/*                            {arquivo.nome}*/}
            {/*                        </a>*/}
            {/*                    </li>*/}
            {/*                ))}*/}
            {/*            </ul>*/}
            {/*        ) : (*/}
            {/*            <p className="text-gray-500">Nenhum arquivo cadastrado.</p>*/}
            {/*        )}*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className={"flex justify-end"}>*/}
            {/*    <div className="mt-2 mb-6">*/}
            {/*        <div className="mt-2">*/}
            {/*            <label htmlFor="file-upload" className="bg-blue-500 text-white py-2 px-4 rounded-md cursor-pointer hover:bg-blue-600 transition">*/}
            {/*                Selecione um Arquivo*/}
            {/*            </label>*/}
            {/*            <input*/}
            {/*                id="file-upload"*/}
            {/*                type="file"*/}
            {/*                className="hidden"*/}
            {/*                onChange={(e) => handleFileChange(e)}*/}
            {/*            />*/}
            {/*            <p id="error-message" className="text-red-500 mt-2 hidden">*/}
            {/*                O arquivo deve ser no formato PDF.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Botão de Fechar */}
            <div className="flex justify-center mt-8">
                <button
                    onClick={onClose}
                    className="glass-button bg-gray-600 hover:bg-gray-700 w-full sm:w-auto px-10"
                >
                    Fechar
                </button>
            </div>
        </div>
    </div>
    );
}
